<template>
 
  <router-view/>
</template>

<style>
#app{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  width: 100%;
}

</style>
//mel the great